module.exports = __webpack_public_path__ + "assets/issemym.7a2aa8f4.svg";